const defaultWidgetsMap = {};

const RenderNothing = (props) => {
  if (process.env.NODE_ENV === "development") {
    console.warn(
      `The widget type ${JSON.stringify(
        props.type
      )} is not supported in MagentoWysiwyg. Please check "theme/modules/WysiwygV2/MagentoWysiwyg/Widget/getWidgetComponent.js" to see what's going on.`
    );
  }
  return null;
};

const getWidgetComponent = (customWidgetsMap) => {
  const widgetsMap = {
    ...defaultWidgetsMap,
    ...(customWidgetsMap || {}),
  };
  return (type) => {
    return widgetsMap[type] || RenderNothing;
  };
};

export default getWidgetComponent;
